import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ["sendConfirmationEmail", "confirmationEmailBody", "discussionOption", "discussionEnabledHint", "discussionDisabledHint"]

  connect() {
     this.toggleChoices();
  }

  toggleChoices() {
    // Show confirmation email body (including business name) when checkbox is checked (regardless of discussion setting)
    if (this.sendConfirmationEmailTarget.checked) {
      this.confirmationEmailBodyTarget.style.display = "block"
    } else {
      this.confirmationEmailBodyTarget.style.display = "none"
    }

    // Always update the reply behavior hint when settings change
    this.updateReplyBehaviorHint()

  }

  updateReplyBehaviorHint() {
    // Only show hint if confirmation emails are enabled
    if (!this.sendConfirmationEmailTarget.checked) {
      return
    }

    const discussionEnabled = this.getDiscussionOptionValue() == "true"
    
    if (this.hasDiscussionEnabledHintTarget && this.hasDiscussionDisabledHintTarget) {
      if (discussionEnabled) {
        this.discussionEnabledHintTarget.style.display = "inline"
        this.discussionDisabledHintTarget.style.display = "none"
      } else {
        this.discussionEnabledHintTarget.style.display = "none"
        this.discussionDisabledHintTarget.style.display = "inline"
      }
    }
  }

  getDiscussionOptionValue() {
    for(var i = 0; i < this.discussionOptionTargets.length; i++) { 
      if(this.discussionOptionTargets[i].checked) {
        return this.discussionOptionTargets[i].value;
      }
    }
  }
}
